import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, Params } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SharedDataService } from './service/shared-data.service';
import { CidaasService } from './service/cidaas.service';
import { Location } from '@angular/common';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EnableRegisterGuard  {
  constructor(private _data: SharedDataService, private cidaas: CidaasService, private _router: Router, private location: Location) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let _requestId = route.queryParams.requestId || route.queryParams.requestid || null;
    let _inviteId = route.queryParams.invite_id || null;
    return this.cidaas._getClientInfoAsObs({ requestId: _requestId })
      .pipe(
        map(value => this.enableRegistration(value, _inviteId, _requestId, route.queryParams)),
        catchError((err) => {
          this.navigateToErrorPage(route.queryParams);
          return of(false);
        })
      )
      .toPromise();
  }



  enableRegistration = (data: any, invite_id: string = '', request_Id: string, params: Params): boolean => {
    if (data?.registration_enabled) {
      return true;
    } else if (data?.invite_enabled && invite_id) {
      return true;
    } else {
      this.navigateToErrorPage(params);
      return false;
    }
  };

  navigateToErrorPage = (params: Params) => {
    const queryParams = {
      ...params,
      ...(!params.error_hint && { error_hint: 'ERROR.MSG' } || {})
    };
    this._router.navigate(['handle_error'],
      {
        queryParams
      });
  }

}


